import React from 'react';
import { Navigate } from 'react-router-dom';

export default function BillingsIndex() {
  return <Navigate to="/billings/account" replace />;
}
